<template>
  <div class="modal-body">
    <form class="floating-labels m-t-40" @submit.prevent="addTaskStatuses()">
      <div class="row">
        <div class="col-12 m-2">
          <!-- Template Name Name -->
          <div
            class="form-group m-b-40"
            :class="[StatusName != null ? '' : 'focused']"
          >
            <span class="p-float-label">
              <input
                type="text"
                class="form-control float-class"
                id="StatusName"
                maxlength="50"
                placeholder=""
                v-model="StatusName"
              /><span class="bar"></span>
              <label for="" id="font1"
                >Task Status<span style="color: red"> </span
              ></label>
            </span>
          </div>
          <!-- Template Name Name -->
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      @click="addTaskStatuses()"
      type="button"
      class="btn btn-outline-success waves-effect waves-light col-12 template-name"
    >
      Add Task Status
    </button>
  </div>

  <!-- Template Name -->
</template>
<script>
import axios from "axios";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
import Swal from "sweetalert2";
export default {
  name: "TaskStatusTable",
  props: ["tableRefreash", "patientTask", "changeTaskStatus", "closeModal"],
  data() {
    return {
      loader: "",
      StatusName: "",
    };
  },
  methods: {
    async addTaskStatuses() {
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      if (this.StatusName === "") {
        this.ShowWarning("Task status name is require");
        event.preventDefault();
        return;
      }
      this.intDummyComm();
      this.dummyComm.extras = this.StatusName;
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/PostTaskStatus",
        data: this.dummyComm,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          const response = res.data;
          debugger;
          if (response.status === true) {
            this.successToastUpd();
            if (this.changeTaskStatus !== undefined) {
              this.changeTaskStatus(this.patientTask, response.data, 1);
            }
            this.closeModal();
          } else {
            this.ShowWarning("Task status name is Duplicate");
          }
        })
        .finally(() => {
          this.tableRefreash();
          this.loader.hide();
          this.StatusName = "";
        });
    },
  },
  mounted() {},
};
</script>
<style>
</style>